import { Experiment } from '@ms/yammer-data/dist/state/types';
import { useExperimentTreatmentWithoutReporting } from '@ms/yammer-hooks/dist/experiments';
import { useCurrentSessionUser } from '@ms/yammer-hooks/dist/session';

import { UseUIFeatureCheck } from '../types';

export {
  useCanCurrentUserAccessAdminSettings as useIsAdminCenterEnabled,
  useShowStorylineAdminSettings as useIsStorylineAdminEnabled,
  useCanCurrentUserAccessWebAdminSettings as useIsAdminCenterWebEnabled,
} from '@ms/yammer-hooks/dist/adminSettings';

export {
  useCanEditNetworkQuestionSettings as useIsQuestionsAdminEnabled,
  useShowAnalyticsSettings as useIsInsightsAdminEnabled,
  useCanViewerEditLeaderSettings as useIsLeadershipCornerAdminEnabled,
  useViewerCanManageComplianceData as useIsComplianceDataAdminEnabled,
} from '@ms/yammer-hooks/dist/adminFeatureAccessSettings';
export { useCanAssignUserAdminRoles as useIsUserRolesAdminEnabled } from '@ms/yammer-hooks/dist/featureAccessSettings';
export { useViewerCanEditUserAchievementsSettings as useIsAchievementsAdminEnabled } from '@ms/yammer-hooks/dist/adminUserAchievementsSettings';
export { useShowLeaderSettings as useIsLeadersAdminEnabled } from '@ms/yammer-hooks/dist/leaderSettings';

export const useIsNetworkAdminEnabled: UseUIFeatureCheck = () => useCurrentSessionUser().isNetworkAdmin;

export const useIsConfigureTenantEnabled: UseUIFeatureCheck = () => {
  const isNetworkAdmin = useIsNetworkAdminEnabled();
  const isConfigureTenantFeatureEnabled =
    useExperimentTreatmentWithoutReporting(Experiment.VivaEngageConfigureTenant) === true;

  return isNetworkAdmin && isConfigureTenantFeatureEnabled;
};
